import { __awaiter, __generator, __read, __spreadArray } from "tslib";
import { fetchSharedContext } from '@office-start/context-service';
import { WEEK_IN_MS } from '@office-start/date-utility';
import { fetchEncryptionKey } from '@office-start/identity-service';
import { createCacheFirstOperation, } from '@office-start/persistence-strategies';
import { createEncryptionPlugin, createExpirationPlugin, readFromSimplePersistence, writeToSimplePersistence, } from '@office-start/simple-persistence';
import { fetchPeoplePicture } from './operations/fetchPeoplePicture';
var personPicturePersistenceKey = 'graph-person-picture-api';
var personPicturePersistenceVersion = 2;
export function executePersonPictureDataFlow(officeComponentContext, identity, pictureId, size) {
    return __awaiter(this, void 0, void 0, function () {
        var officeHomeApiRoot, jwtAuthEnabled, correlationId, getAccessToken, _a, sharedContext, encryptionKey, pluginsForWrite, options, picturePersistenceKey;
        var _this = this;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    officeHomeApiRoot = officeComponentContext.officeHomeApiRoot, jwtAuthEnabled = officeComponentContext.jwtAuthEnabled, correlationId = officeComponentContext.correlationId, getAccessToken = officeComponentContext.getAccessToken;
                    return [4 /*yield*/, Promise.all([
                            fetchSharedContext(),
                            fetchEncryptionKey(),
                        ])];
                case 1:
                    _a = __read.apply(void 0, [_b.sent(), 2]), sharedContext = _a[0], encryptionKey = _a[1];
                    if (!sharedContext) {
                        return [2 /*return*/, Promise.reject('Invalid shared context')];
                    }
                    pluginsForWrite = [];
                    if (encryptionKey === null || encryptionKey === void 0 ? void 0 : encryptionKey.key) {
                        pluginsForWrite.push(createEncryptionPlugin(encryptionKey.key));
                    }
                    pluginsForWrite.push(createExpirationPlugin(4 * WEEK_IN_MS));
                    options = {
                        officeApiRoot: officeHomeApiRoot,
                        jwtAuthEnabled: jwtAuthEnabled,
                        correlationId: correlationId,
                        getAccessToken: getAccessToken,
                        graphApiRoot: sharedContext.graphApiRoot,
                        pictureId: pictureId,
                        size: size,
                    };
                    picturePersistenceKey = "".concat(pictureId, "-").concat(size);
                    return [2 /*return*/, createCacheFirstOperation(function () { return fetchPeoplePicture(options); }, function () {
                            // Reverse order of plugins used for write so they play back
                            // in the correct order.
                            var pluginsForRead = __spreadArray([], __read(pluginsForWrite), false).reverse();
                            return readFromSimplePersistence({
                                userId: identity.puid,
                                collectionName: personPicturePersistenceKey,
                                collectionVersion: personPicturePersistenceVersion,
                                key: picturePersistenceKey,
                                hashKey: true,
                                plugins: pluginsForRead,
                            });
                        }, function (networkPayload) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, writeToSimplePersistence({
                                            userId: identity.puid,
                                            collectionName: personPicturePersistenceKey,
                                            collectionVersion: personPicturePersistenceVersion,
                                            key: picturePersistenceKey,
                                            hashKey: true,
                                            data: networkPayload,
                                            plugins: pluginsForWrite,
                                            writeBehavior: 'sync',
                                        })];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
            }
        });
    });
}
//# sourceMappingURL=executePersonPictureDataFlow.js.map